<template>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="700">
        <span class="markerpen"  v-if="show">
            <font>{{ $state['filingStatus'][row.status] }}</font>
        </span>
        <table class="QHtable"  v-if="show">
            <tr>
                <th colspan="100"><b>备案详情</b></th>
            </tr>
            <tr>
                <td style="width:125px;"><b>备案编号</b></td>
                <td>
                    {{ row.NO }}
                </td>
            </tr>
            <tr>
                <td style="width:125px;"><b>排放单位</b></td>
                <td>{{ row.name }}</td>
            </tr>
            <tr>
                <td><b>排放垃圾</b></td>
                <td>{{ row.garbageTypeName }}</td>
            </tr>
            <tr>
                <td><b>排放数量</b></td>
                <td>{{ row.garbageNumber }}m³</td>
            </tr>
            <tr>
                <td><b>排放时间</b></td>
                <td>{{ $timeFmt(row.emissionTime, "YYYY-MM-DD") }}</td>
            </tr>
            <tr>
                <td><b>排放地址</b></td>
                <td>{{ row.addressFull }}</td>
            </tr>
            <tr>
                <td><b>联系姓名</b></td>
                <td>{{ row.contactName }}</td>
            </tr>
            <tr>
                <td><b>联系电话</b></td>
                <td>{{ row.contactTel }}</td>
            </tr>
            <tr>
                <td><b>申请时间</b></td>
                <td>{{ $timeFmt(row.created, "YYYY-MM-DD HH:mm") }}</td>
            </tr>
            <tr>
                <th colspan="100"><b>关联信息</b></th>
            </tr>
            <tr>
                <td><b>垃圾图片</b></td>
                <td v-if="!$isblank(row.filingImg)">
                    <QHImgList :list="row.filingImg"></QHImgList>
                </td>
                <td v-if="$isblank(row.filingImg)">
                    暂无垃圾图片
                </td>
            </tr>
            <tr>
                <td style="width:125px;"><b>关联工地</b></td>
                <td v-if="row.projectId > 0">{{ row.projectName || '工地信息丢失' }}</td>
                <td v-else>暂无关联工地</td>
            </tr>
            <tr>
                <td style="width:125px;"><b>客户单位</b></td>
                <td v-if="row.projectId > 0">{{ row.orgNamePaifang || '单位信息丢失' }}</td>
                <td v-else>暂无关联单位</td>
            </tr>
            <tr>
                <td><b>小程序码</b></td>
                <td>
                    <p v-if="$isblank(row.qcodeUrl)">未生成备案码</p>
                    <p v-if="!$isblank(row.qcodeUrl)"><span class="CL9"
                            style="cursor: pointer;color: gray;margin-left:5px;"
                            @click="$openImg(row.qcodeUrl)">查看备案码</span></p>
                </td>
            </tr>
        </table>
    </Modal>
</template>

<script>
export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            title: "备案详情",
            show: false,
            row: {}
        }
    },
    methods: {
        // +----------------------------------------------------------------------
        // | Desc:唤起修改
        // +----------------------------------------------------------------------
        hiPop(e) {
            console.log(e);
            this.$loading(true);
            this.$api.getFilingDetailed({ id: e.id }).then((res) => {
                this.$loading(false);
                if (res.code == 0) {
                    this.row = res.data;
                    this.show = true;
                } else {
                    this.$msg(res.msg, "error");
                };
            });
        }
    }
};
</script>